/**
 * Insights hub (owner 2026-07-15): the Insights tab houses MULTIPLE reports —
 * a card grid, click a card to open the report (the MIPS card-navigation
 * pattern). Cards carry a LIVE SUMMARY on their face (owner feedback
 * 2026-07-15 — match the MIPS Insights card richness). Reports register
 * here as they land.
 */
import { Skeleton } from '@/components/ui/skeleton';
import { useAco } from '@/contexts/AcoContext';
import { useProgramYear } from '@/contexts/ProgramYearContext';
import { AcoHeader, NoAcoState, YearUnsupportedState } from './components/AcoHeader';
import { RosterExposureCard } from './components/RosterExposureCard';
import { TinNpiPerformanceCard } from './components/TinNpiPerformanceCard';
import { RequestCustomReportCard } from '@/components/insights/RequestCustomReportCard';
import { AppPlusDataService } from '@/lib/app-plus-data-service';

export default function AppPlusInsights() {
  const { selectedAco, loading } = useAco();
  const { programYear } = useProgramYear();
  const yearSupported = AppPlusDataService.getInstance().getSupportedYears().includes(programYear);

  if (!yearSupported) return <YearUnsupportedState year={programYear} />;
  if (loading) {
    // Shell-first (owner 2026-07-20): page chrome renders immediately.
    return (
      <div>
        <AcoHeader title="Insights" subtitle="Reports and analytics for your ACO" />
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
          <Skeleton className="h-72 rounded-lg" />
          <Skeleton className="h-72 rounded-lg" />
        </div>
      </div>
    );
  }
  if (!selectedAco) return <NoAcoState />;

  return (
    <div>
      <AcoHeader title="Insights" subtitle="Reports and analytics for your ACO" />

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <RosterExposureCard />
        <TinNpiPerformanceCard />
        <RequestCustomReportCard
          program="app-plus"
          entityType="aco"
          entityId={selectedAco.id}
          entityLabel={`${selectedAco.aco_id_cms} — ${selectedAco.name}`}
          programYear={programYear}
        />
      </div>
    </div>
  );
}
